"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingsAndReviewsSummary = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("./components");
const utils_1 = require("./utils");
const styles_1 = require("./styles");
const RatingsAndReviewsSummary = ({ ariaProps = {}, handleClickRatingReviewCount, providerReviews, ratingReviewCountHref, shouldHidePageAnchors = false }) => {
    const aggregateRatings = providerReviews === null || providerReviews === void 0 ? void 0 : providerReviews.aggregate_ratings;
    if (!aggregateRatings) {
        return null;
    }
    const ratingCount = aggregateRatings.rating_count;
    const reviewCount = aggregateRatings.review_count;
    const averageRating = aggregateRatings.average_rating;
    const { ratingReviewCountLabeledBy, ratingReviewCountLinkId } = ariaProps;
    return (react_1.default.createElement(styles_1.RatingsAndReviewsContainer, null,
        (0, utils_1.showAverageRating)(aggregateRatings) ? (react_1.default.createElement(components_1.StarRating, { averageRating: averageRating })) : null,
        react_1.default.createElement(components_1.RatingsAndReviewsCount, { ariaLabeledBy: ratingReviewCountLabeledBy, handleClickRatingReviewCount: handleClickRatingReviewCount, ratingCount: ratingCount, ratingReviewCountHref: ratingReviewCountHref, ratingReviewCountLinkId: ratingReviewCountLinkId, reviewCount: reviewCount, shouldHidePageAnchors: shouldHidePageAnchors })));
};
exports.RatingsAndReviewsSummary = RatingsAndReviewsSummary;
//# sourceMappingURL=RatingsAndReviewsSummary.js.map